<template>
    <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="12">
                        Resumen de Respuestas Ingresadas por Municipalidades
                    </v-col>
                    
            
                </v-row>
                 <v-row class="col-md-12 pt-0 pb-0 mb-0">
                    <v-col cols="12" md="5" sm="5" xs="12" class="pt-0 pb-0 mb-0">
                        <v-select
                            v-model="datosItem.periodoMedicionId"
                            :items="periodos"
                            :loading="ddPeriodosLoading"
                            dense
                            outlined
                            label="Periodo de medición"
                            item-text="anioMedicion"
                            item-value="id"
                            :no-data-text="periodos!=null ? 'Selecciona un periodo' : 'No se han encontrado periodos'"
                            @change="establecido=false;"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="7" sm="7" xs="12" class="pt-0 pb-0 mb-0">
                        <v-select
                            v-model="indiceSeleccionadoId"
                            :items="indices"
                            :loading="ddIndicesLoading"
                            :disabled="datosItem.periodoMedicionId<=0"
                            dense
                            outlined
                            label="Seleccionar Índice"
                            item-text="nombreIndice"
                            item-value="id"
                            :hint="datosItem.periodoMedicionId<=0 ? 'Debe seleccionar un periodo de medición' : ''"
                            :no-data-text="indices ? 'Selecciona un índice' : 'No se han registrado índices'"
                            @change="obtenerBoletasPorIndice(); establecido=false;"
                        ></v-select>
                    </v-col>
                </v-row>

                <v-row class="col-md-12 pt-0 mt-0">
                    <v-col cols="12" md="5" sm="5" xs="12" class="pt-0 mt-0 pb-1">
                        <v-select
                            v-model="datosItem.boletasId"
                            :items="boletas"
                            :loading="ddBoletasLoading"
                            dense
                            outlined
                            label="Seleccionar boleta"
                            item-text="descripcion"
                            item-value="id"
                            :no-data-text="indices.length<=0 ? 'No se ha seleccionado un índice' : 'El índice seleccionado no tiene boletas asignadas'"
                            @change="establecido=false;"
                        ></v-select>
                    </v-col>

                     <v-col cols="12" md="7" sm="7" xs="12" class="pt-0 mt-0 pb-1">
                        <v-btn
                            color="primary"
                            class="mb-2 float-right bg-light-blue"
                            @click="obtenerrespuestasAprobadas();"
                            :disabled="datosItem.boletasId<=0 || indiceSeleccionadoId<=0"
                        >
                            Buscar
                            <v-icon right>mdi-magnify</v-icon>
                        </v-btn>
                    </v-col> 

                    
                </v-row>

                <v-row v-if="establecido==false">
                    <v-col cols="12">
                        <v-alert
                            text
                            prominent
                            type="error"
                            icon="mdi-alert"
                            dense
                            small
                            >
                                <p class="mt-3">Para poder exportar respuestas, debes de establecer la configuración de periodo de medición, índice y boleta.</p> 
                            </v-alert>
                    </v-col>
                </v-row>

                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>

            
                        
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="4" md="4" xs="12">
                        <!--<download-excel 
                            class="btn btn-md btn-primary bg-light-blue" 
                            :fetch="exportarTabla" 
                            :disabled="true"
                            worksheet="DICCIONARIO_RESPUESTAS"
                        >
                            EXPORTAR
                            <v-icon left>mdi-database-export</v-icon>
                            </download-excel>-->

                        <v-btn
                            color="primary"
                            class="mb-2 float-right bg-light-blue"
                            @click="exportTest();"
                            
                        >
                            Exportar a Excel
                            <v-icon right>mdi-database-export</v-icon>
                        </v-btn>
                    
                    </v-col> 

                    <v-col cols="12" md="8" sm="8" xs="12">
                        <v-text-field
                            outlined
                            autocomplete="off"
                            dense
                            v-model="tableFilter"
                            label="Buscar"
                            maxlength="100"
                        ></v-text-field>
                    </v-col>

                   
                </v-row>


                <SubHeader subHeaderTitle="RESPUESTAS DE MUNICIPALIDADES " />

                <v-row class="mx-0 mb-2" dense>
                    <v-col cols="12">
                        <div class="d-flex flex-wrap align-center">
                            <div
                                v-for="criterio in criteriosColor"
                                :key="criterio.texto"
                                class="d-flex align-center mr-6 mb-1"
                            >
                                <span
                                    class="d-inline-block mr-2"
                                    :style="{ width: '14px', height: '14px', borderRadius: '3px', backgroundColor: criterio.color }"
                                ></span>
                                <span class="caption">{{ criterio.texto }} ({{ criterio.total }})</span>
                            </div>
                        </div>
                    </v-col>
                </v-row>

                <SubHeader subHeaderTitle="RESUMEN POR MUNICIPIO" />

                <v-row class="mx-0 mb-2" dense>
                    <v-col cols="12">
                        <v-data-table
                            :headers="headersResumen"
                            :items="resumenPorMunicipio"
                            item-key="codigoMunicipio"
                            class="elevation-0"
                            :loading="tableLoading"
                            no-data-text="No hay datos para mostrar"
                            :items-per-page="100"
                            :footer-props="{
                                showFirstLastPage: true,
                                firstIcon: 'mdi-page-first',
                                lastIcon: 'mdi-page-last',
                                prevIcon: 'mdi-chevron-left',
                                nextIcon: 'mdi-chevron-right',
                                'items-per-page-text':'Registros por página',
                                pageText: '{0}-{1} de {2}'
                            }"
                            dense
                        >
                            <!-- <template
                                v-for="criterio in criteriosColor"
                                v-slot:[`item.${criterio.clave}`]="{ item }"
                            >
                                <span :key="criterio.clave" :style="{ color: criterio.color, fontWeight: 600 }">
                                    {{ item[criterio.clave] }}
                                </span>
                            </template> -->
                        </v-data-table>
                    </v-col>
                </v-row>

            </v-card-text>
        </v-card>

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import Vue from 'vue';
import moment from "moment";
import XLSX from 'xlsx-js-style';

import validations from "@/core/untils/validations.js";
import SubHeader from "@/view/components/subheader/SubHeader";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_INDICES } from "@/core/services/store/catalogos/indice.module";
import { OBTENER_PERIODOS } from "@/core/services/store/catalogos/periodomedicion.module";
import { OBTENER_BOLETAS } from "@/core/services/store/boletas/boleta.module";
import { OBTENER_RESPUESTAS_MUNI_APROBADAS2 } from "@/core/services/store/preguntasperiodoboleta/preguntaperiodoboleta.module";


import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";

moment.locale('es');
Vue.filter("formatDate", function(value) {
    if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
    }
});

//!Definición centralizada de los criterios de color según el cruce entre estadoRevision y estadoAprobacion
const CRITERIOS = [
    { clave: 'rojo', color: '#e53935', colorExcel: 'FFE53935', texto: 'Con inconsistencia y no aprobada', filtro: (er, ea) => er == 2 && ea == 2 },
    { clave: 'naranja', color: '#fb8c00', colorExcel: 'FFFB8C00', texto: 'Con inconsistencia y sin proceso de aprobación', filtro: (er, ea) => er == 2 && (ea === null || ea === undefined) },
    { clave: 'azul', color: '#1e88e5', colorExcel: 'FF1E88E5', texto: 'Sin inconsistencia y sin proceso de aprobación', filtro: (er, ea) => er == 1 && (ea === null || ea === undefined) },
    { clave: 'amarillo', color: '#fdd835', colorExcel: 'FFFDD835', texto: 'Con inconsistencia y aprobada', filtro: (er, ea) => er == 2 && ea == 1 },
    { clave: 'verde', color: '#43a047', colorExcel: 'FF43A047', texto: 'Sin inconsistencia y no aprobada', filtro: (er, ea) => er == 1 && ea == 2 },
    { clave: 'negro', color: '#000000', colorExcel: 'FF000000', texto: 'Sin inconsistencia y aprobada', filtro: (er, ea) => er == 1 && ea == 1 }
];
const CRITERIO_SIN_RESPUESTA = { clave: 'sinRespuesta', color: '#9e9e9e', colorExcel: 'FF9E9E9E', texto: 'Sin respuesta' };

export default {
    name: "ConfiguracionBoletas",
    components: {
        SnackAlert,
        SubHeader,
        DialogLoader
    },
    data() {
        return {
            tableLoading: false,
            ddPreguntasLoading:false,
            ddBoletasLoading:false,
            ddSubPreguntasLoading:false,
            respuestasAprobadas:[],
            respuestaColumnas:[],
            datosExportacionEstados: [],
            tableFilter:'',
            validForm:false,
            validForm2: false,
            establecido:false,
            itemName: "Índices",
            dialog: false,
            dialogAsingarSub:false,
            modalTitle: 'Registrar Índice',
            btnRegistroLoading: false,
            btnRegistroSubLoading:false,
            dialogLoaderVisible: false,
            activePicker:null,
            menuFechaApertura: false,
            menuFechaCierre:false,
            fechas: {
                fechaApertura:'',
                fechaCierre: '',
            },
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Guardar',
            accion: 1,
            indices: [],
            indiceSeleccionadoId:0,
            preguntas: [],
            subpreguntas:[],
            subPreguntasAsignadas:[],
            datosExportacion: [],
            subPreguntaSeleccionadaId:0,
            preguntasAsignar:[],
            boletas: [],
            ddIndicesLoading: false,
            ddPeriodosLoading: false,
            periodos: [],
            switchItemEstado: true,
            visitaCampoValores: [{id: 'SI', visita: 'Si'}, {id: 'NO', visita: 'No'}],
            datosItem: {
                id: 0,
                preguntasId:0,
                visitaCampo: 'No',
                noOrdenPregunta: "0",
                periodoMedicionId: 0,
                boletasId:0,
                estadosId: 1
            },
            ...validations
        } 
    }, 
    methods: {
        //!Definir la fecha máxima que se puede seleccionar en el datepicker
        maxDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear() + 1);
            return date.toISOString().substr(0, 10);
        },

        //!Definir la fecha minima que se puede seleccionar en el datepicker
        minDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear());
            return date.toISOString().substr(0, 10);
        },


        modalNueva(){
            this.accion =1;
            this.modalTitle='Asignar pregunta a boleta';
            this.btnRegistroText='Guardar';
            this.switchItemEstado=true;
            this.dialog=true;
        },

        resetForm(){
           // this.$refs.form.reset();
            let boletaSeleccionada = this.datosItem.boletasId;
             this.datosItem= {
                id: 0,
                preguntasId: 0,
                boletasId: boletaSeleccionada,
                noOrdenPregunta: "0",
                periodoMedicionId: this.datosItem.periodoMedicionId,
                indicesId: 0,
                estadosId: 1
            };
            this.accion=1;
            this.switchItemEstado = true;
            //console.log(this.switchItemEstado)
        },

        resetFormSub(){
            this.accion=1;

        },

        async obtenerIndices(){
            this.indices=[];
            this.ddIndicesLoading=true;
            await this.$store
            .dispatch(OBTENER_INDICES, 1)
            .then(res => {
                if(res.status===200){
                    this.indices=res.data;
                } else {
                    console.warn(res.message)
                }
                this.ddIndicesLoading=false;
               
            }
            )
            .catch(() => {
                this.ddIndicesLoading=false;
                //console.warn(err)
            });
        },


        //!Obtener boletas por indice seleccionado y periodo
        async obtenerBoletasPorIndice(){

            this.datosItem.boletasId=0;
            this.boletas=[];
            this.ddBoletasLoading=true;
            await this.$store
            .dispatch(OBTENER_BOLETAS, {idPeriodo: this.datosItem.periodoMedicionId, idIndice: this.indiceSeleccionadoId})
            .then(res => {
                if(res.status===200){
                    this.boletas=res.data;
                } else {
                    console.warn(res.message)
                }
                this.ddBoletasLoading=false;
               
            }
            )
            .catch(() => {
                this.ddBoletasLoading=false;
                //console.warn(err)
            });
        },


        //!Determinar si una respuesta de "total" debe mostrarse aunque no esté revisada/aprobada
        esRespuestaTotalSiempreVisible(nombreRespuesta){
            if(!nombreRespuesta) return false;
            const textosExcluidos = ['número total de empleados municipales', 'total proyectos poa'];
            const nombreNormalizado = nombreRespuesta.toLowerCase();
            if(textosExcluidos.includes(nombreNormalizado)){
                return false;
            }
            return nombreNormalizado.includes('total');
        },

        //!Obtener los periodos para la tabla
        obtnenerPeriodosMedicion(){
            this.ddPeriodosLoading = true;
            this.periodos=[];
            
            this.$store
                .dispatch(OBTENER_PERIODOS)
                .then(() => {
                    this.periodos = this.$store.state.periodomedicion.periodos;
                    this.ddPeriodosLoading =false;
                })
                .catch(() => {
                    this.ddPeriodosLoading = false;
                });

        },

    //!Obtener el diccionario de respuestas por periodo y boleta
    async obtenerrespuestasAprobadas(){
         this.establecido=true;
          this.tableLoading=true;
          this.respuestasAprobadas=[];
          this.respuestaColumnas=[];
            await this.$store
            .dispatch(OBTENER_RESPUESTAS_MUNI_APROBADAS2, {boletaId:this.datosItem.boletasId, periodoId: this.datosItem.periodoMedicionId})
            .then(res => {
                if(res.status===200){

                    //!Obtener el listado único de respuestas (columnas), descartando las que no inician con una numeración de tres grupos (ej. 3.1.1) o cuyo idRespuesta esté excluido, ya que no todos los municipios tienen las mismas respuestas
                    const patronNumeracion = /^(\d+)\.(\d+)\.(\d+)/;
                    const columnasMap = new Map();
                    res.data.forEach(element => {
                        element.respuestas.forEach(respuesta => {

                            const textoParaNumeracion = respuesta.textoPreguntaParent || respuesta.textoPregunta || '';
                            const coincidencia = textoParaNumeracion.match(patronNumeracion);
                                if(!coincidencia){
                                    return;
                                }
                            
                            
                            if(!columnasMap.has(respuesta.idRespuesta)){
                                columnasMap.set(respuesta.idRespuesta, {
                                    idRespuesta: respuesta.idRespuesta,
                                    nombreRespuesta: respuesta.nombreRespuesta,
                                    textoPregunta: respuesta.textoPregunta || '',
                                    textoPreguntaParent: respuesta.textoPreguntaParent || '',
                                    numeracion: [Number(coincidencia[1]), Number(coincidencia[2]), Number(coincidencia[3])]
                                });
                            }
                        });
                    });
                    this.respuestaColumnas = Array.from(columnasMap.values())
                        .sort((a, b) => {
                            for(let i = 0; i < 3; i++){
                                if(a.numeracion[i] !== b.numeracion[i]){
                                    return a.numeracion[i] - b.numeracion[i];
                                }
                            }
                            return a.idRespuesta - b.idRespuesta;
                        });

                    this.respuestasAprobadas = [];
                    this.datosExportacion = [];
                    this.datosExportacionEstados = [];

                    //!Armar una fila por municipio con una columna por cada respuesta, dejando vacío cuando el municipio no tenga esa respuesta
                    res.data.forEach(element => {
                        const respuestasPorId = new Map(element.respuestas.map(r => [r.idRespuesta, r]));

                        const fila = {
                            codigoDepartamento: element.codigoDepartamento,
                            nombreDepartamento: element.nombreDepartamento,
                            codigoMunicipio: element.codigoMunicipio,
                            nombreMunicipio: element.nombreMunicipio
                        };

                        let arr = [];
                        arr["Codigo Departamento"] = element.codigoDepartamento;
                        arr["Nombre Departamento"] = element.nombreDepartamento;
                        arr["Codigo Municipio"] = element.codigoMunicipio;
                        arr["Nombre Municipio"] = element.nombreMunicipio;

                        let estadosFila = {};

                        this.respuestaColumnas.forEach(columna => {
                            const respuesta = respuestasPorId.get(columna.idRespuesta);
                            const valor = respuesta && respuesta.respuesta;
                            const estadoRevision = respuesta ? respuesta.estadoRevision : null;
                            const estadoAprobacion = respuesta ? respuesta.estadoAprobacion : null;
                            fila[`r_${columna.idRespuesta}`] = valor;
                            fila[`r_${columna.idRespuesta}_estadoRevision`] = estadoRevision;
                            fila[`r_${columna.idRespuesta}_estadoAprobacion`] = estadoAprobacion;
                            arr[columna.nombreRespuesta] = valor;
                            estadosFila[columna.nombreRespuesta] = { estadoRevision, estadoAprobacion };
                        });

                        this.respuestasAprobadas.push(fila);
                        this.datosExportacion.push(arr);
                        this.datosExportacionEstados.push(estadosFila);
                    });
                } else {
                    //console.warn(res.message)
                    this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                }
                this.tableLoading=false;
            })
            .catch(() => {
                this.tableLoading=false;
                this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                });
        
    },


    exportarTabla(){
        
        
        if(this.datosExportacion.length<=0){
             this.$refs.snackalert.SnackbarShow('warning', 'Mensaje', "No se han encontrado respuestas para exportar!");
            
        } else {
        this.dialogLoaderText= "Exportando respuestas...";
        this.dialogLoaderVisible=true;
        /*let datosExportacion = this.respuestasAprobadas.map(item => {
            return {
                "Id Respuesta": item.idRespuesta,
                "Nombre Respuesta": item.nombreRespuesta,
                "Tipo de Dato": item.tipoDato,
                "Id Pregunta": item.preguntaId,
                "Nombre Pregunta": item.nombrePregunta,
                "Id Pregunta Superior": item.idPreguntaSuperior,
                "Nombre Pregunta Superior": item.nombrePreguntaSuperior
            };
        });*/

        //console.log(datosExportacion);
        this.dialogLoaderVisible=false;
        return this.datosExportacion;
        }
    },


    //!Determinar color, color en hexadecimal para Excel y texto descriptivo según el cruce entre estadoRevision y estadoAprobacion
    obtenerEstadoInfo(estadoRevision, estadoAprobacion){
        const encontrado = CRITERIOS.find(c => c.filtro(estadoRevision, estadoAprobacion));
        return encontrado || { color: null, colorExcel: null, texto: null };
    },

    //!Determinar a qué criterio (clave) pertenece una respuesta según su estadoRevision/estadoAprobacion, usado para los conteos por municipio
    obtenerClaveCriterio(estadoRevision, estadoAprobacion){
        const encontrado = CRITERIOS.find(c => c.filtro(estadoRevision, estadoAprobacion));
        return encontrado ? encontrado.clave : CRITERIO_SIN_RESPUESTA.clave;
    },

    tieneInconsistencia(estadoRevision){
        return estadoRevision == 2;
    },

    exportTest(){
      var animalWS = XLSX.utils.json_to_sheet(this.datosExportacion)

      const columnasFijas = 4;
      this.datosExportacionEstados.forEach((estadosFila, filaIndex) => {
          this.respuestaColumnas.forEach((columna, colIndex) => {
              const estado = estadosFila[columna.nombreRespuesta];
              if(!estado) return;
              const info = this.obtenerEstadoInfo(estado.estadoRevision, estado.estadoAprobacion);
              if(!info.colorExcel) return;
              const direccionCelda = XLSX.utils.encode_cell({ r: filaIndex + 1, c: columnasFijas + colIndex });
              const celda = animalWS[direccionCelda];
              if(celda){
                  celda.s = {
                      font: { color: { rgb: info.colorExcel }, bold: true }
                  };
              }
          });
      });

      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, animalWS, 'RESPUESTAS') // sheetAName is name of Worksheet

      // export Excel file
      XLSX.writeFile(wb, 'indice.xlsx') // name of the file is 'book.xlsx'
    },


  


      

     
  
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Respuestas" },
            { title: "Exportación" }
        ]);
    },

    created(){
        this.obtenerIndices();
       // this.obtnenerItems();
        this.obtnenerPeriodosMedicion();
    },

    
    computed: {
        headers() {
            const base = [
                {
                    text: "Codigo municipio",
                    align: "start",
                    sortable: false,
                    value: "codigoMunicipio"
                },
                 {
                    text: "Municipio",
                    align: "start",
                    sortable: false,
                    value: "nombreMunicipio"
                }
            ];

            const dinamicos = this.respuestaColumnas.map(columna => ({
                text: columna.textoPreguntaParent == columna.textoPregunta 
                    ? columna.textoPreguntaParent + " - " + columna.nombreRespuesta
                    : columna.textoPreguntaParent + " - " + columna.textoPregunta + " - " + columna.nombreRespuesta,
                align: "start",
                sortable: false,
                value: `r_${columna.idRespuesta}`
            }));

            return base.concat(dinamicos);
        },

        //!Listado de criterios de color a mostrar como leyenda, incluyendo el total global de respuestas que cae en cada criterio
        criteriosColor(){
            return CRITERIOS.concat([CRITERIO_SIN_RESPUESTA]).map(c => ({
                ...c,
                total: this.conteoTotalPorCriterio[c.clave] || 0
            }));
        },

        //!Conteo global (todos los municipios) de respuestas por cada criterio de color
        conteoTotalPorCriterio(){
            const conteos = { rojo: 0, naranja: 0, azul: 0, amarillo: 0, verde: 0, negro: 0, sinRespuesta: 0 };
            this.respuestasAprobadas.forEach(fila => {
                this.respuestaColumnas.forEach(columna => {
                    const estadoRevision = fila[`r_${columna.idRespuesta}_estadoRevision`];
                    const estadoAprobacion = fila[`r_${columna.idRespuesta}_estadoAprobacion`];
                    const clave = this.obtenerClaveCriterio(estadoRevision, estadoAprobacion);
                    conteos[clave]++;
                });
            });
            return conteos;
        },

        //!Conteo por municipio de cuántas respuestas caen en cada criterio de color, con columna de total
        resumenPorMunicipio(){
            return this.respuestasAprobadas.map(fila => {
                const conteos = { rojo: 0, naranja: 0, azul: 0, amarillo: 0, verde: 0, negro: 0, sinRespuesta: 0 };
                this.respuestaColumnas.forEach(columna => {
                    const estadoRevision = fila[`r_${columna.idRespuesta}_estadoRevision`];
                    const estadoAprobacion = fila[`r_${columna.idRespuesta}_estadoAprobacion`];
                    const clave = this.obtenerClaveCriterio(estadoRevision, estadoAprobacion);
                    conteos[clave]++;
                });
                return {
                    codigoMunicipio: fila.codigoMunicipio,
                    nombreDepartamento: fila.nombreDepartamento,
                    nombreMunicipio: fila.nombreMunicipio,
                    ...conteos,
                    total: this.respuestaColumnas.length
                };
            });
        },

        //!Encabezados de la tabla resumen por municipio, usando el texto del criterio como nombre de columna
        headersResumen(){
            const base = [
                { text: "Codigo municipio", align: "start", sortable: false, value: "codigoMunicipio" },
                { text: "Departamento", align: "start", sortable: false, value: "nombreDepartamento" },
                { text: "Municipio", align: "start", sortable: false, value: "nombreMunicipio" }
            ];

            const columnasCriterios = CRITERIOS.concat([CRITERIO_SIN_RESPUESTA]).map(c => ({
                text: c.texto,
                align: "center",
                sortable: false,
                value: c.clave
            }));

            return base.concat(columnasCriterios, [
                { text: "Total", align: "center", sortable: false, value: "total" }
            ]);
        },

        //Cambiar el formato de fechas a DD-MM-YYY para mostrar y a YYYY-MM-DD para registrar en datosItem.fechaApertura
        fechaApertura:{
            get: function(){
                return this.fechas.fechaApertura
                ? moment(this.fechas.fechaApertura).format("DD-MM-YYYY")
                : null;
            },
            set: function(val){
                
                this.datosItem.fechaApertura = moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD');
                return val;
            }
        },   
        
        //Cambiar el formato de fechas a DD-MM-YYY para mostrar y a YYYY-MM-DD para registrar en datosItem.fechaCierre
        fechaCierre:{
            get: function(){
                return this.fechas.fechaCierre
                ? moment(this.fechas.fechaCierre).format("DD-MM-YYYY")
                : null;
            },
            set: function(val){
                
                this.datosItem.fechaCierre = moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD');
                return val;
            }
        },   
    },

    watch: {
        
        //Cambiar el formato de fecha de apertura/cierre del objeto datosItem al momento de que fechas.fechaApertura/fechas.fechaCierre cambie
        'fechas.fechaApertura': function(val){
            this.datosItem.fechaApertura = val;
        },

        'fechas.fechaCierre': function(val){
            this.datosItem.fechaCierre = val;
        },

    
    }

    
}
</script>
<style lang="">
    
</style>